// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"296":"32fd9b8c","960":"1c45510c"}[chunkId] + ".chunk.js";
};